import { render, staticRenderFns } from "./product-section.component.vue?vue&type=template&id=2d97faa9&scoped=true&"
import script from "./product-section.component.ts?vue&type=script&lang=ts&"
export * from "./product-section.component.ts?vue&type=script&lang=ts&"
import style0 from "./product-section.component.scss?vue&type=style&index=0&id=2d97faa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97faa9",
  null
  
)

export default component.exports